import React from 'react'
import { Alert, AlertTitle, Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import tradeArrowRed from 'src/assets/new-landing/cl_trade_arrow_red.svg'
import { useHelper } from '../HelperContext'

export const FormTitle = ({ id, children }) => {
  const { styles, loginError } = useHelper()
  const theme = useTheme()
  const isBelowSm = useMediaQuery(theme.breakpoints.down('sm'))

  return <Stack gap='4px' mb={loginError ? '1.5rem' : { xs: '2rem', md: '3rem' }}>
    <Stack direction='row' gap='.5rem'
      alignItems='center' justifyContent='start'
    >
      <Typography variant='h4' id={id}
        color='text.primary' textAlign='start'
      >
        {children}
      </Typography>
      {isBelowSm && <Box className={`${styles.TradeArrow} ${styles.mobile}`}>
        <img src={tradeArrowRed} alt="CrimsonLogic Trade Arrow" />
      </Box>}
    </Stack>
    <Typography variant='caption' id="loginHelper" className={styles.Note}>
      All <span className={styles.Required} />
      &nbsp;fields are mandatory
    </Typography>
    {loginError && <Alert severity="error">
      <AlertTitle>Login Error</AlertTitle>
      {loginError}
    </Alert>}
  </Stack>
}